<template>
  <ModalStructure
    :class="$style.recapModal"
    :showModal="true"
    showCloseButton
    @close="handleClose"
  >
    <template v-slot:header>
      <HeadingMedium
        data-test-id="RecapsModal__title"
      >
        {{ featureName }}
      </HeadingMedium>
    </template>

    <template v-slot:body>
      <div
        :class="$style.recapList"
      >
        <Card
          v-for="recap in recapData"
          :key="recap.name"
          :class="$style.recapCard"
          data-test-id="RecapsModal__list"
          type="default"
        >
          <template #body>
            <HeadingSmall
              :hasMargin="false"
            >
              {{ recap.value }}
            </HeadingSmall>
            <span>{{ recap.name }}</span>
          </template>
        </Card>
      </div>
    </template>

    <template v-slot:footer>
      <div
        :class="$style.recapFooter"
      >
        <div
          v-if="disclaimerText"
          :class="$style.disclaimerText"
          data-test-id="RecapsModal__disclaimerText"
        >
          {{ disclaimerText }}
        </div>
        <div :class="$style.actionBtnContainer">
          <Button
            data-test-id="RecapsModal__upgradeBtn"
            text="Request Upgrade"
            type="primary"
            @click="requestUpgrade"
          />
        </div>
      </div>
    </template>
  </ModalStructure>
</template>
<script>
import {
  Button,
  Card,
  HeadingMedium,
  HeadingSmall,
  ModalStructure,
} from '@jumpcloud/ui-components';
import { mapGetters } from 'vuex';

import {
  accountEmail,
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import Util from 'client/util/Util';

const modalName = 'Trial Recap Modal';

export default {
  name: 'RecapsModal',

  EventHelper,
  ModalEventBus,
  Util,

  components: {
    Button,
    Card,
    HeadingMedium,
    HeadingSmall,
    ModalStructure,
  },

  props: {
    disclaimerText: {
      type: String,
      default: () => '',
    },
    featureName: {
      type: String,
      required: true,
    },
    planName: {
      type: String,
      required: true,
    },
    recapData: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters('AccountManagerCalendarModule', {
      accountManagerCalendarUrl: 'getAccountManagerCalendarUrl',
    }),
  },

  methods: {
    emitSegmentEvent({
      type, description, section, location, iconName, text,
    }) {
      this.$options.EventHelper[type]({
        [eventProperties.location]: location,
        [eventProperties.description]: description,
        [eventProperties.section]: section,
        [eventProperties.iconName]: iconName,
        [eventProperties.text]: text,
      });
    },

    handleClose() {
      this.emitSegmentEvent({
        type: 'triggerIconClicked',
        description: 'Closes CAP Trial Recap Modal',
        iconName: 'close',
        location: `${this.featureName} Recap Modal`,
        section: 'top right hand corner',
        text: 'X',
      });

      ModalEventBus.close();
    },

    requestUpgrade() {
      if (this.accountManagerCalendarUrl) {
        this.emitSegmentEvent({
          type: 'triggerButtonClicked',
          location: `${this.featureName} ${modalName}`,
          description: 'Request upgrade button clicked to open Request Upgrade Modal',
          section: 'middle',
          text: 'Request Upgrade',
        });
        this.$options.ModalEventBus.open({
          component: 'UpgradeModal',
          isLargeModal: true,
          componentProps: {
            calendarUrl: this.accountManagerCalendarUrl,
            eventLocation: `${eventLocations.upgradePage}, ${this.featureName}, ${modalName}`,
            packageInfo: this.planName,
            showModal: true,
          },
        });
      } else {
        this.emitSegmentEvent({
          type: 'triggerButtonClicked',
          location: `${this.featureName} ${modalName}`,
          description: 'Request upgrade button clicked to open Send Email to Request',
          section: 'middle',
          text: 'Request Upgrade',
        });
        this.$options.Util.openUrl(`mailto:${accountEmail}?subject=${this.planName || 'JumpCloud'} upgrade request`);
      }
    },
  },
};
</script>
<style scoped module>
.actionBtnContainer {
  text-align: right;
  width: 100%;
}

.disclaimerText {
  margin-bottom: var(--jc-spacer-medium);
}

.recapList {
  display: flex;
  flex-wrap: wrap;
  gap: var(--jc-spacer-medium);
  justify-content: flex-start;
}

.recapCard {
  background: var(--jcWhite100);
  border-color: var(--jc-color-success-subdued);
  flex: 1 1 30%;
  max-width: 30%;
}

.recapModal.recapModal {
  --modal-width: 60vw;
}

.recapFooter {
  flex: 1;
  flex-direction: column;
}
</style>
